import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { APP_PATHS } from '../config/app-paths';
import { AdminPanelUsersNavigationContextService } from '../../shared/services/admin-panel-users-navigation-context.service';
import { AdminPanelUsersNavigationContextMode } from '../../shared/enums/admin-panel-users-navigation-context-mode.enum';

export const AdminPanelUsersNavigationContextGuard: CanActivateFn = (
  route,
) => {
  const router = inject(Router);
  const navigationContext = inject(AdminPanelUsersNavigationContextService);
  const redirectTo = `/${APP_PATHS.admin.root}/${APP_PATHS.admin.users}`;
  const contextMode = route.data['contextMode'];

  if (
    contextMode === AdminPanelUsersNavigationContextMode.UserDetails &&
    navigationContext.hasUserDetailsContext()
  ) {
    return true;
  }

  if (
    contextMode ===
      AdminPanelUsersNavigationContextMode.OrganizationDetails &&
    navigationContext.hasUserOrganizationDetailsContext()
  ) {
    return true;
  }

  return router.createUrlTree([redirectTo]);
};
